(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-premium"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // ── Countdown timer ──
    const countdownEl = document.querySelector('#hero-premium-{{ section.id }} [data-countdown]');
    if (countdownEl) {
      const endDate = new Date(countdownEl.dataset.countdown).getTime();
      const daysEl = countdownEl.querySelector('[data-days]');
      const hoursEl = countdownEl.querySelector('[data-hours]');
      const minsEl = countdownEl.querySelector('[data-minutes]');
      const secsEl = countdownEl.querySelector('[data-seconds]');

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        const now = Date.now();
        const diff = endDate - now;

        if (diff <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minsEl.textContent = '00';
          secsEl.textContent = '00';
          return;
        }

        const days  = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const mins  = Math.floor((diff % 3600000) / 60000);
        const secs  = Math.floor((diff % 60000) / 1000);

        daysEl.textContent  = pad(days);
        hoursEl.textContent = pad(hours);
        minsEl.textContent  = pad(mins);
        secsEl.textContent  = pad(secs);
      }

      tick();
      setInterval(tick, 1000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
